import { injectLoginApi } from '@delmonicos/shared-sdk/libs/emsp/src/clients/redux/back-office/login.service';
import { baseApi } from '@service/base.api';

export const loginApi = injectLoginApi(baseApi);

export const { useLoginMutation, useSendOtpMutation, useVerifyOtpMutation } =
  loginApi;
